import { render, staticRenderFns } from "./builder.vue?vue&type=template&id=0444913e&scoped=true&"
import script from "./builder.vue?vue&type=script&lang=js&"
export * from "./builder.vue?vue&type=script&lang=js&"
import style0 from "./builder.vue?vue&type=style&index=0&id=0444913e&lang=scss&scoped=true&"
import style1 from "./builder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0444913e",
  null
  
)

export default component.exports